import type { TFunction } from "@/lib/i18n";
import type { EnumUnion } from "@dresscode-frontend/utility-types";

export const ContactPreference = {
  PHONE: "PHONE",
  EMAIL: "EMAIL",
} as const;

export type ContactPreference = EnumUnion<typeof ContactPreference>;

export const ContactPreferenceOptions = (
  t: TFunction<"translation", "common">,
) => [
  {
    id: ContactPreference.PHONE,
    label: t("contactPreference.PHONE"),
  },
  {
    id: ContactPreference.EMAIL,
    label: t("contactPreference.EMAIL"),
  },
];
